import { useState } from 'react'
import Section from '@/components/Section'
import { SERVICES } from '@/data/landing'

export default function ServicesSection() {
  const [expanded, setExpanded] = useState(false)

  return (
    <div id="services" className="py-24 px-6 max-w-[960px] mx-auto">
      <Section>
        <div className="text-center mb-14">
          <span className="inline-block py-1.5 px-4 rounded-full bg-brand-mid/10 text-brand-mid text-[11px] font-semibold tracking-[2px] uppercase mb-4">
            Done-for-You Services
          </span>
          <h2 className="font-display text-[clamp(30px,5vw,44px)] font-bold text-text-dark leading-[1.15] mb-4">
            Want Me to Just Do It?
          </h2>
          <p className="text-text-gray text-[17px] max-w-[480px] mx-auto leading-relaxed">
            If you'd rather focus on ministry and let someone else handle the tech — that's literally what I do.
          </p>
        </div>
      </Section>

      <div className="relative">
        <div className={`overflow-hidden transition-all duration-500 ${expanded ? 'max-h-[1600px]' : 'max-h-[390px] md:max-h-[430px]'}`}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {SERVICES.map((svc, i) => (
              <Section key={i} delay={`${i * 0.08}s`}>
                <div className="bg-card-bg rounded-2xl p-7 border border-card-border h-full transition-all duration-300 hover:shadow-[0_8px_30px_rgba(28,18,40,0.06)]">
                  <span className="text-[30px] block mb-3">{svc.emoji}</span>
                  <div className="font-bold text-[16px] text-text-dark mb-2">{svc.title}</div>
                  <div className="text-text-gray text-[15px] leading-relaxed">{svc.desc}</div>
                </div>
              </Section>
            ))}
          </div>
        </div>

        {!expanded ? (
          <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-28 bg-gradient-to-t from-[#F9F7FC] via-[#F9F7FC]/92 to-transparent" />
        ) : null}
      </div>

      <Section>
        <div className="text-center mt-8 flex flex-col items-center gap-4">
          <button
            type="button"
            onClick={() => setExpanded((v) => !v)}
            className="inline-block py-2.5 px-6 rounded-full border border-brand-mid/25 bg-white text-brand-mid text-sm font-semibold transition-all duration-200 hover:scale-[1.02] hover:bg-brand-mid/5"
          >
            {expanded ? 'View Less' : 'View More'}
          </button>
          <a
            href="#book"
            className="inline-block py-4 px-10 rounded-full bg-brand-dark text-white text-base font-bold no-underline shadow-[0_4px_30px_rgba(21,13,46,0.2)] transition-all duration-200 hover:scale-[1.03] hover:shadow-[0_6px_40px_rgba(21,13,46,0.3)]"
          >
            Book a Free 15-Minute Call
          </a>
        </div>
      </Section>
    </div>
  )
}
